module.exports = __webpack_public_path__ + "static/img/coming.820b600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/genetic/coming.png
// module id = yG/+
// module chunks = 1